import { comments } from '../../lib/api';

/**
 * AddCommentOnly - Submits a comment to the backend
 *
 * Async function (not a React component) that posts a comment to the backend API.
 * Constructs payload with optional metadata (action, location, attached media files).
 *
 * @param {Object} params
 * @param {string|null} params.metaAction - Optional action metadata
 * @param {string} params.itemHash - Target item hash to comment on
 * @param {string|null} params.actionLocation - Optional location metadata
 * @param {Object|null} params.actionMedia - Optional media: { url: string, name: string }
 * @param {string} params.comment - Comment text content
 * @returns {Promise<object>} Backend response
 */
const AddCommentOnly = async ({metaAction, itemHash, actionLocation, actionMedia, comment}) =>{

    let jData = { hash: itemHash, comment: comment, forUser: null, meta: {}}

    if(metaAction) jData.meta.action = metaAction
    if(actionLocation) jData.meta.actionLocation = actionLocation
    if(actionMedia && actionMedia?.url) { jData.meta.fileObjects = [{url: actionMedia?.url, name: actionMedia?.name, mime: "image/jpg"}] }

    await comments(jData);

}

export default AddCommentOnly;
